import {Stack} from "@mui/material";

export interface SectionActionBarProps {
    children?: React.ReactNode;
}

export default function SectionActionBar(props: Readonly<SectionActionBarProps>) {
    const {children} = props;
    return (
            <Stack direction={"row"} spacing={1}>
                {children}
            </Stack>
    );
}